import { render, staticRenderFns } from "./solutions.vue?vue&type=template&id=260a1328&scoped=true"
import script from "./solutions.vue?vue&type=script&lang=js"
export * from "./solutions.vue?vue&type=script&lang=js"
import style0 from "./solutions.vue?vue&type=style&index=0&id=260a1328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260a1328",
  null
  
)

export default component.exports